import { Component, Input } from '@angular/core';
import { Progress } from '@org/interfaces';
import { ModalComponent } from './modal.component';
import { CommonModule, DatePipe } from '@angular/common';
import { CommentsTooltipComponent } from '../commentsTooltip/comments-tooltip.component';


@Component({
  selector: 'app-blueprint-progress-modal',
  imports: [ModalComponent, CommonModule, CommentsTooltipComponent],
  templateUrl: './blueprint-progress-modal.component.html',
  styleUrls: ['./blueprint-progress-modal.component.css']
})
export class BlueprintProgressModalComponent {
  @Input() data!: Progress;
  close!: () => void; 

  // Comment tooltip state
  tooltipVisible = false;
  tooltipComments: any[] = [];
  tooltipPosition = { x: 0, y: 0 };
  private tooltipHideTimeout: any;

 
  getStatusLabel(taskCompleted: boolean): string {
    return taskCompleted ? 'Complete' : 'Incomplete';
  }

  getAssignedAssignees(task: any) {
    return (task.potentialAssignees || []).filter((a: any) => a.isAssigned);
  }

  hasAssignedAssignees(task: any) {
    return this.getAssignedAssignees(task).length > 0;
  }

  isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  showCommentsTooltip(event: MouseEvent, comments: any[]) {
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    const tooltipWidth = 384; // 24rem (w-96) in px
    // Place tooltip to the left of the icon
    const leftX = rect.left - tooltipWidth - 12; // 12px gap
    const centerY = rect.top + rect.height / 2 - 100; // 200px is half of tooltip height (w-96 is 384px wide, height is up to 400px)

    if (this.isMobile()) {
      this.tooltipVisible = !this.tooltipVisible;
      this.tooltipComments = comments;
      this.tooltipPosition = { x: window.innerWidth / 2 - tooltipWidth / 2, y: window.innerHeight / 4 };
    } else {
      clearTimeout(this.tooltipHideTimeout);
      this.tooltipVisible = true;
      this.tooltipComments = comments;
      this.tooltipPosition = { x: leftX, y: centerY };
    }
  }

  hideCommentsTooltip() {
    this.tooltipVisible = false;
    this.tooltipComments = [];
  }

  scheduleHideTooltip() {
    this.tooltipHideTimeout = setTimeout(() => {
      this.tooltipVisible = false;
      this.tooltipComments = [];
    }, 100); // 100ms delay to allow mouse to enter tooltip
  }
  
  cancelHideTooltip() {
    clearTimeout(this.tooltipHideTimeout);
  }

  statusRenderer(status: string) {
    return status === 'completed' ? 'Complete' : 'Incomplete';
  }

  RequestStatusRenderer(status: string) {
    return status === 'in_progress' ? 'In Progress' : 'Pending';
  }
}